import Et3Button from "../../../../../../core/et3-button";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import getTBWStore from "../../../../../../stores/developer-store/tbw-store";
import { banFromTBW } from "../../../../../../stores/developer-store/tbw-store/ban-from-tbw";
import getUserStore from "../../../../../../stores/user-store";

const TBWShortcutActions = withLiteObserverAndTheme<{
  reportID: number;
  reportedID: number;
  reportedUUID: string;
  pageName: string;
}>((props) => {
  const { reportID, reportedID, reportedUUID, pageName, theme } = props;
  const { colors } = theme;
  const shouldHide = pageName === "AUDITOR_AUDIT";
  return !shouldHide ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={1115}
      height={50}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        onClick={async () => {
          getTBWStore().setTBWActionDataShortcuts({
            actionName: "banned",
            extraData: {
              reportID,
              reportedID,
              reportedUUID,
              userID: -1,
              userUUID: "",
              secondPartyID: -1
            },
            reason: [{ label: "Scammer", value: "69" }]
          });

          await banFromTBW();
          getTBWStore().resetTBWActionDataShortcut();
        }}
        size={"DEFAULT"}
        isEnabled={true}
        text="BAN_SCAMMER"
        type="REJECT"
      />
      <Et3Margin top={0} bottom={0} left={0} right={100} />
      <Et3Button
        onClick={async () => {
          getTBWStore().setTBWActionDataShortcuts({
            actionName: "warning",
            extraData: {
              reportID,
              reportedID,
              reportedUUID,
              userID: -1,
              userUUID: "",
              secondPartyID: -1
            },
            reason: [{ label: "Social Media Accounts", value: "88" }]
          });

          await getUserStore().warnUser();
          getTBWStore().resetTBWActionDataShortcut();
        }}
        size={"DEFAULT"}
        isEnabled={true}
        text="WARN_SOCIAL_MEDIA_ACCOUNT"
        type="WARN"
      />
      <Et3Margin top={0} bottom={0} left={0} right={100} />
      <Et3Button
        onClick={async () => {
          getTBWStore().setTBWActionDataShortcuts({
            actionName: "warning",
            extraData: {
              reportID,
              reportedID,
              reportedUUID,
              userID: -1,
              userUUID: "",
              secondPartyID: -1
            },
            reason: [
              {
                label: "Being Disrespectful | Bad Language | Rudeness",
                value: "8"
              }
            ]
          });

          await getUserStore().warnUser();
          getTBWStore().resetTBWActionDataShortcut();
        }}
        size={"DEFAULT"}
        isEnabled={true}
        text="WARN_BAD_LANGUAGE"
        type="WARN"
      />
    </ET3Div>
  ) : null;
});

export default TBWShortcutActions;
